import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import {
  medicationsActions,
  laboratoriesActions,
  medicationsTypesActions,
  medicationsClassificationActions,
  dcbNamesActions,
  messageActions
} from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'
import ChipInput from 'material-ui-chip-input'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { fetchMedication } from '../../actions/medications'
import { medications } from '../../api'
import { fetchNamesDcb } from '../../actions/namesDcb'
import * as API from '../../api'
import TextField from '@material-ui/core/TextField'
import SelectWrapped from '../../components/SelectWrapped'
import Chip from '@material-ui/core/Chip'
import { formatContentSelectValueSingle, filterOptionsFunction } from '../../utils'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  componentDidMount() {
    const { fetchLaboratoriesAll } = this.props
    fetchLaboratoriesAll()

    const { fetchMedicationsTypes } = this.props
    fetchMedicationsTypes()

    const { fetchMedicationsClassification } = this.props
    fetchMedicationsClassification()
  }

  handleSave = medication => {
    const { onClose, addMedication, editMedication, changeMessage } = this.props
    if (medication._id) {
      editMedication(medication).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addMedication(medication).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, medication) => {
    e.preventDefault()
    const { setMedicationFormTouched } = this.props
    if ((this.props.medicationFormErrors || {}).valid) {
      this.handleSave(medication)
    } else {
      setMedicationFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  handleAddSinonimo = sinonimo => {
    const { medication = '' } = this.props
    let sinonimos = medication.sinonimos || []

    const duplicated = sinonimos.find(
      item => item.trim().toLowerCase() === sinonimo.trim().toLowerCase()
    )

    sinonimos = duplicated ? sinonimos : [...sinonimos, sinonimo]

    this.props.handleChangeMedication({ ...medication, sinonimos: sinonimos || [] })
  }

  handleDeleteSinonimo = sinonimo => {
    const { medication = '' } = this.props
    let sinonimos = medication.sinonimos || []

    sinonimos = sinonimos.filter(item => item !== sinonimo)

    this.props.handleChangeMedication({ ...medication, sinonimos: sinonimos || [] })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      namesDcb,
      medicationsClassification,
      medicationsTypes,
      laboratories,
      medication,
      handleChangeMedication,
      loadingMedication,
      medicationFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('medicamentos', token)

    return (
      <div>
        <Dialog
          modalId={medication._id ? 'medicamentos-editar' : 'medicamentos-novo'}
          modalParams={{ registro: medication._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingMedication ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(medication._id ? 'medicamentos-editar' : 'medicamentos-novo') + '-title'}>
                {isReadOnly ? (
                  'Medicamentos'
                ) : (
                  <Fragment>
                    {medication._id ? 'Editar medicamento' : 'Cadastrar medicamento'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'medication-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, medication)
                  }}
                >
                  <FormControl
                    error={
                      !((medicationFormErrors.fields || {})['nome'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Nome</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeMedication({ ...medication, nome: e.target.value })
                      }}
                      value={medication.nome}
                      autoFocus
                      id="field-nome"
                    />

                    {!((medicationFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((medicationFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((medicationFormErrors.fields || {})['codigo_ean'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-codigo_ean">Código EAN</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeMedication({ ...medication, codigo_ean: e.target.value })
                      }}
                      value={medication.codigo_ean}
                      id="field-codigo_ean"
                    />

                    {!((medicationFormErrors.fields || {})['codigo_ean'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((medicationFormErrors.fields || {})['codigo_ean'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((medicationFormErrors.fields || {})['sinonimos'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <ChipInput
                      disabled={isReadOnly}
                      id="field-sinonimos"
                      value={medication.sinonimos ? medication.sinonimos : []}
                      label={'Sinônimos'}
                      inputProps={{
                        form: 'non-form'
                      }}
                      onAdd={this.handleAddSinonimo}
                      onDelete={this.handleDeleteSinonimo}
                      chipRenderer={(
                        {
                          value,
                          text,
                          isFocused,
                          isDisabled,
                          handleClick,
                          handleDelete,
                          className
                        },
                        key
                      ) => (
                        <Chip
                          key={key}
                          className={className}
                          style={{
                            pointerEvents: isDisabled ? 'none' : undefined,
                            backgroundColor: isFocused ? 'black' : undefined
                          }}
                          onClick={handleClick}
                          onDelete={isDisabled ? null : handleDelete}
                          label={text}
                        />
                      )}
                    />
                    {!((medicationFormErrors.fields || {})['sinonimos'] || {}).valid &&
                      formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((medicationFormErrors.fields || {})['sinonimos'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((medicationFormErrors.fields || {})['nomeDcb_id'] || {}).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <TextField
                      disabled={isReadOnly}
                      fullWidth
                      onChange={obj => {
                        handleChangeMedication({ ...medication, nomeDcb_id: obj })
                      }}
                      error={
                        !((medicationFormErrors.fields || {})['nomeDcb_id'] || {}).valid &&
                        formTouched
                      }
                      value={formatContentSelectValueSingle(medication.nomeDcb_id || {})}
                      placeholder="Selecione..."
                      name="react-select-chip-label"
                      label="Nome DCB"
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        inputComponent: SelectWrapped,
                        inputProps: {
                          multi: false,
                          filterOptions: filterOptionsFunction,
                          instanceId: 'react-select-chip-label',
                          id: 'react-select-chip-label',
                          loadOptions: API.namesDcb.getSelectNamesDcb,
                          disableDelete: isReadOnly
                        }
                      }}
                    />
                    {!((medicationFormErrors.fields || {})['nomeDcb_id'] || {}).valid &&
                      formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((medicationFormErrors.fields || {})['nomeDcb_id'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">Laboratórios</InputLabel>
                    <Select
                      disabled={isReadOnly}
                      error={
                        !((medicationFormErrors.fields || {})['laboratorio'] || {}).valid &&
                        formTouched
                      }
                      onChange={e => {
                        clearErrors()
                        handleChangeMedication({
                          ...medication,
                          laboratorio_id: e.target.value
                        })
                      }}
                      value={medication.laboratorio_id || ''}
                    >
                      {console.log(laboratories)}
                      {!!(laboratories) &&
                        (laboratories || []).map(laboratorio => (
                          <MenuItem key={laboratorio._id} value={laboratorio._id}>
                            {laboratorio.nome}
                          </MenuItem>
                        ))}
                    </Select>
                    {!((medicationFormErrors.fields || {})['laboratorio'] || {}).valid &&
                      formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((medicationFormErrors.fields || {})['laboratorio'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((medicationFormErrors.fields || {})['apresentacao'] || {}).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-apresentacao">Apresentação</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeMedication({ ...medication, apresentacao: e.target.value })
                      }}
                      value={medication.apresentacao}
                      id="field-apresentacao"
                    />

                    {!((medicationFormErrors.fields || {})['apresentacao'] || {}).valid &&
                      formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((medicationFormErrors.fields || {})['apresentacao'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">Tipo</InputLabel>
                    <Select
                      disabled={isReadOnly}
                      error={
                        !((medicationFormErrors.fields || {})['tipoMedicamento'] || {}).valid &&
                        formTouched
                      }
                      onChange={e => {
                        clearErrors()
                        handleChangeMedication({
                          ...medication,
                          tipoMedicamento_id: e.target.value
                        })
                      }}
                      value={medication.tipoMedicamento_id || ''}
                    >
                      {(medicationsTypes || []).map(
                        tipoMedicamento =>
                          !tipoMedicamento.deletedAt && (
                            <MenuItem key={tipoMedicamento._id} value={tipoMedicamento._id}>
                              {tipoMedicamento.nome}
                            </MenuItem>
                          )
                      )}
                    </Select>
                    {!((medicationFormErrors.fields || {})['tipoMedicamento'] || {}).valid &&
                      formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {
                          ((medicationFormErrors.fields || {})['tipoMedicamento'] || {})
                            .errorMessage
                        }
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">Classificação</InputLabel>
                    <Select
                      disabled={isReadOnly}
                      error={
                        !((medicationFormErrors.fields || {})['classificacaoMedicamento'] || {})
                          .valid && formTouched
                      }
                      onChange={e => {
                        clearErrors()
                        handleChangeMedication({
                          ...medication,
                          classificacaoMedicamento_id: e.target.value
                        })
                      }}
                      value={medication.classificacaoMedicamento_id || ''}
                    >
                      {(medicationsClassification || []).map(
                        classificacaoMedicamento =>
                          !classificacaoMedicamento.deletedAt && (
                            <MenuItem
                              key={classificacaoMedicamento._id}
                              value={classificacaoMedicamento._id}
                            >
                              {classificacaoMedicamento.nome}
                            </MenuItem>
                          )
                      )}
                    </Select>
                    {!((medicationFormErrors.fields || {})['classificacaoMedicamento'] || {})
                      .valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {
                          ((medicationFormErrors.fields || {})['classificacaoMedicamento'] || {})
                            .errorMessage
                        }
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'medication-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    namesDcb: state.namesDcb.namesDcb,
    medicationsClassification: state.medicationClassification.medicationsClassification,
    medicationsTypes: state.medicationsTypes.medicationsTypes,
    laboratories: state.laboratories.laboratories,
    medication: state.medications.medication,
    loadingMedication: state.medications.loadingMedication,
    medicationFormErrors: state.medications.medicationFormErrors,
    formTouched: state.medications.medicationFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(medicationsActions.openModal())
    },
    closeModal: () => {
      dispatch(medicationsActions.closeModal())
    },
    handleChangeMedication: medication => {
      dispatch(medicationsActions.handleChangeMedication(medication))
    },
    addMedication: medication => {
      return dispatch(medicationsActions.addMedication(medication))
    },
    editMedication: medication => {
      return dispatch(medicationsActions.editMedication(medication))
    },
    setMedicationFormTouched: medication => {
      dispatch(medicationsActions.setMedicationFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    fetchLaboratoriesAll: options => {
      dispatch(laboratoriesActions.fetchLaboratoriesAll(options))
    },
    fetchMedicationsTypes: options => {
      dispatch(medicationsTypesActions.fetchMedicationsTypes(options))
    },
    fetchMedicationsClassification: options => {
      dispatch(medicationsClassificationActions.fetchMedicationsClassification(options))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Medications/EditModal.js